import React, { Fragment } from 'react';
import { object, array, bool, string, number } from 'prop-types';
import { ParameterizedText } from '../ParameterizedText';
import { CarouselLink } from '../../CarouselLink';

export const TYPES = {
    TEXT: 'text',
    LINK: 'link',
};

export const TitleSection = ({
    textSections,
    className,
    textWrapperClassname,
    isTitle = false,
    isSubtitle = false,
    dataEnrichment,
    withIcon = true,
    serviceId = null,
    componentDataSource = null,
}) => {
    if (!textSections) {
        return null;
    }
    let Wrapper;

    if (isTitle) {
        Wrapper = 'h4';
    } else if (isSubtitle) {
        Wrapper = 'small';
    } else {
        Wrapper = React.Fragment;
    }

    return (
        <Wrapper className={className}>
            {textSections.map((section, idx) => (
                <Fragment key={idx}>
                    <SectionMapper
                        parameterizedTextClassName={textWrapperClassname}
                        section={section}
                        dataEnrichment={dataEnrichment}
                        withIcon={withIcon}
                        serviceId={serviceId}
                        componentDataSource={componentDataSource}
                    />
                    &nbsp;
                </Fragment>
            ))}
        </Wrapper>
    );
};

const SectionMapper = ({
    section,
    dataEnrichment,
    parameterizedTextClassName,
    withIcon,
    serviceId,
    componentDataSource,
}) => {
    const { type } = section;

    switch (type) {
        case TYPES.TEXT:
            return (
                <ParameterizedText
                    className={parameterizedTextClassName}
                    section={section}
                    withIcon={withIcon}
                    serviceId={serviceId}
                    componentDataSource={componentDataSource}
                />
            );
        case TYPES.LINK:
            return <CarouselLink urlData={section} dataEnrichment={dataEnrichment} />;
        default:
            return null;
    }
};

TitleSection.propTypes = {
    className: string,
    textWrapperClassname: string,
    textSections: array,
    isTitle: bool,
    isSubtitle: bool,
    dataEnrichment: object,
    withIcon: bool,
    serviceId: number,
    componentDataSource: string,
};

SectionMapper.propTypes = {
    section: object.isRequired,
    dataEnrichment: object,
    parameterizedTextClassName: string,
    withIcon: bool,
    serviceId: number,
    componentDataSource: string,
};
